import React, { useEffect } from "react";
import { useLoaderData } from "react-router-dom";
import { GET_COLLECTION } from "../hooks/useInventory";
import Four0Four from "./404";
import { Tile } from "../components/views";
import { useQuery } from "@apollo/client";
import Pagination from "../components/pagination";
import URI from "urijs";
import { findUrlForMedia } from "../utils";
import useResponsive from "../hooks/useResponsive";
import LoaderComponent from "../components/loader";

const Collection = ({ id }) => {
  const { data: { id: idFromLoader } } = useLoaderData();
  const { isMobile } = useResponsive();
  const currentUri = new URI(location.pathname + location.search);
  const search = currentUri.search(true);
  const currentPage = parseInt(search.page) || 1;
  const { data } = useQuery(GET_COLLECTION, { variables: { id: id || idFromLoader, page: currentPage, limit: 24 } });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (data?.collection === undefined) return <LoaderComponent isCentered />;
  else if (!data?.collection === null) return <Four0Four />;

  const { collection, page } = data.collection;

  return (
    <div id="collection">
      <Pagination pagination={page.pagination} currentUri={currentUri} />
      <div className="header">
        <h1>{collection.title}</h1>
        {collection?.banner?.media ? <div className="banner">
          <img src={findUrlForMedia(collection.banner.media, isMobile ? "small" : "banner-free-ratio")} />
        </div> : null }
        {collection?.description ? <div className="description">
        <div dangerouslySetInnerHTML={{ __html: collection.description?.content }} />
      </div> : null }
      </div>
      <div className="entries">
        {page.items.map(e => (<Tile key={e.id} item={e} />))}
      </div>
      <Pagination pagination={page.pagination} currentUri={currentUri} />
    </div>
  );
};

const Loader = async props => {
  return { data: { id: parseInt(props.params.id) } };
};

const Routes = (homepage) => {
  const routes = [{
    path: "/collection/:id/:slug",
    element: <Collection />,
    loader: Loader
  }];
  if (homepage?.type === "collection") {
    const uri = new URI(homepage?.handle);
    routes.push({
      path: "/",
      element: <Collection id={parseInt(uri.segment(1))} />,
      loader: Loader
    });
  }
  return routes;
};

export default Collection;
export { Routes };
